export class Reminder {
	constructor(
		public date_start?: string,
		public date_end?: string,
		public type_reminder?: number,
		public days_of_week?: Array<any>,
		public ordinal_month?: number,
		public ordinal_day?: number,
		public active?: boolean,
	) { }
}